export default "__VITE_ASSET__DtmjgBkg__"